import type { DriveStep } from 'driver.js';

export const teacherDashboardTour: DriveStep[] = [
  {
    element: '[data-tour="next-steps"]',
    popover: {
      title: 'Your next steps',
      description:
        'This checklist tracks your journey — from profile approval to your first published offering. Steps check off automatically as you complete them.',
    },
  },
  {
    element: '[data-tour="offerings-nav"]',
    popover: {
      title: 'My Offerings',
      description:
        'Create and manage what you teach. Once an offering is reviewed and published, students can discover and contact you.',
    },
  },
  {
    element: '[data-tour="inquiries-nav"]',
    popover: {
      title: 'Student Inquiries',
      description:
        'Student messages land here. Fast replies improve your conversion and ranking.',
    },
  },
  {
    element: '[data-tour="help"]',
    popover: {
      title: 'Need help?',
      description: 'Ask the help assistant anything — profile review times, pricing, verification, and more.',
    },
  },
];

export const studentDashboardTour: DriveStep[] = [
  {
    element: '[data-tour="next-steps"]',
    popover: {
      title: 'Your next steps',
      description:
        'Your goal is set! This checklist guides you from browsing teachers to your first conversation. It updates automatically.',
    },
  },
  {
    element: '[data-tour="search-nav"]',
    popover: {
      title: 'Find Teachers',
      description:
        'Search results are pre-filtered to your subject and grade. Compare profiles, reviews, and pricing.',
    },
  },
  {
    element: '[data-tour="inquiries-nav"]',
    popover: {
      title: 'My Inquiries',
      description: 'Conversations with teachers live here — you\u2019ll see replies and unread messages at a glance.',
    },
  },
  {
    element: '[data-tour="help"]',
    popover: {
      title: 'Need help?',
      description: 'The help assistant answers questions about safety, pricing, and how BookMyCoaching works.',
    },
  },
];
